module.exports = __webpack_public_path__ + "static/media/Logo ManyFlow E.c476c193.svg";